import { useQuery } from '@tanstack/react-query';

import { getSupportedCurrencies } from '@/modules/common/api/currencies.api';

const CURRENCIES_QUERY_KEY = ['currencies'];
const CURRENCIES_STALE_TIME = 5 * 60 * 1000;

interface UseCurrenciesOptions {
  /** When false the query will not execute. Defaults to true. */
  enabled?: boolean;
}

/**
 * Fetches the list of supported currencies.
 * Uses a shared query key and stale time so multiple consumers share the same cache.
 */
export function useCurrencies({ enabled = true }: UseCurrenciesOptions = {}) {
  const {
    data: currencies = [],
    isLoading: isLoadingCurrencies,
    error: currenciesError,
  } = useQuery({
    queryKey: CURRENCIES_QUERY_KEY,
    queryFn: getSupportedCurrencies,
    staleTime: CURRENCIES_STALE_TIME,
    enabled,
  });

  return { currencies, isLoadingCurrencies, currenciesError };
}
